import { MEDIUM_FOOTER } from '@mds/mds-reactjs-library';
import { StyledFooter } from './Footer.styles';

const FEEDBACK_EMAIL = 'performancelens_growthcube@mckinsey.com';
const MAILTO_HREF = `mailto:${FEEDBACK_EMAIL}`;

export function FooterMediumDemo() {
  return (
    <StyledFooter
      type={MEDIUM_FOOTER}
      linksConfig={[
        {
          label: (
            <>
              <span
                data-component="mdc-c-icon"
                className="mdc-c-icon mck-email-icon ggc-footer-contact__icon"
                aria-hidden
              />
              <span className="mdc-c-link__label">Contact us</span>
            </>
          ),
          href: MAILTO_HREF,
          className:
            'ggc-footer-contact mdc-c-button mdc-c-button--secondary mdc-c-button--size-large',
          title: 'Contact Global Growth Cube',
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      ]}
    />
  );
}

export { FooterMediumDemo as Footer };
